// Index.tsx
export const AUDIO_INPUT = "audioinput"
export const AUDIO_OUTPUT = "audiooutput"
export const TEST_AUDIO_OUTPUT = "test_audio_output.mp3"